import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import { BOGLE_LIGHT, BOGLE_REGULAR } from '../../../constants/constant';

const useStyles = makeStyles(() => ({
	container: {
		padding: '0 16px 0 16px',
	},
	textArrangement: {
		textAlign: 'center',
	},
	title: {
		fontSize: '16px',
		fontFamily: BOGLE_REGULAR,
		fontWeight: 400,
	},
	content: {
		fontSize: '14px',
		fontFamily: BOGLE_LIGHT,
	},
}));

export const NoData = ({ title, content }) => {
	const classes = useStyles();
	return (
		<Box className={classes.container}>
			<Box className={classes.textArrangement}>
				<Typography variant="h6" className={classes.title}>
					{title}
				</Typography>
			</Box>
			<Box className={classes.textArrangement}>
				<Typography variant="p" className={classes.content}>
					{content}
				</Typography>
			</Box>
		</Box>
	);
};

NoData.propTypes = {
	title: PropTypes.string,
	content: PropTypes.string,
};

export default NoData;
